import queryRole from './queryRole';
import getQueryRole from './getQueryRole';
import setRoleData from './setRoleData';
import overrideUser from './overrideUser';

export default {
    queryRole,
    getQueryRole,
    setRoleData,
    overrideUser,
};



// WEBPACK FOOTER //
// ./src/api/systemManage/job/index.ts